export default __webpack_public_path__ + "static/app-screen-6-28c4e081617e49d812c139260ec68211.png";